(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
	var scrollspy = require('scrollspy');

	var countTo = function (els) {
		els.each(function () {
			var el = $(this);
			var title = el.find('h3');
			var number = parseInt(title.text());

			if (!isNaN(number)) {
				var numberStr = '' + number;
				var unit = title.text().substr(numberStr.length);
				var currNumber = 0;

				title.text(currNumber + unit);

				var interval = setInterval(function () {
					window.requestAnimationFrame(function () {
						if (currNumber == number) {
							clearInterval(interval);
						}
						else {
							currNumber++;

							title.text(currNumber + unit);
						}
					});
				}, 1);
			}
		});
	};

	$('.numbers').each(function () {
		var wrap = $(this);
		var articles = wrap.find('article');

		scrollspy([wrap[0]], {
			inView: function (el) {
				if (!el.classList.contains('was-in-view')) {
					countTo(articles);
				}

				el.classList.add('was-in-view');
				el.classList.add('in-view');
			},
			outView: function (el) {
				el.classList.remove('in-view');
			}
		});
	});
})();
